module.exports = __webpack_public_path__ + "static/img/1_3_5.8ce3fc52.jpg";